import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import withStyles from '@material-ui/core/styles/withStyles';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import buttonStyle from 'assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx';

const ActionableSongListItem = ({
  data,
  toggleIsFavorite,
  inFavorites,
  listType,
  classes,
  index,
}) => {
  const [isFavorite, setIsFavorite] = useState(inFavorites);

  const onClickIcon = async () => {
    await toggleIsFavorite(data);
    setIsFavorite(!isFavorite);
  };

  return (
    <GridContainer key={data.title}>
      <GridItem xs={4} style={{ margin: '0px' }}>
        <Link to={`/swipe/collection/${listType}/${index}`}>
          <img
            style={{
              borderRadius: '10px',
              display: 'block',
              width: '100%',
              marginBottom: '5px',
            }}
            className={classes.profilePic}
            src={data.imgsrc}
            alt="Album Artwork"
          />
        </Link>
      </GridItem>
      <GridItem xs={5} style={{ margin: '20px 24px 0px -10px' }}>
        <Link to={`/swipe/collection/${listType}/${index}`}>
          <h5
            style={{
              color: '#171055',
              fontWeight: '600',
              fontSize: '14px',
            }}
            className={classes.description}
          >
            {data.title}
          </h5>
          <h6 style={{ fontWeight: '300' }} className={classes.description}>
            <b>{data.artist}</b>
          </h6>
        </Link>
      </GridItem>
      <GridItem xs={1} style={{ margin: '24px 5px 0px 0px' }}>
        {isFavorite ? (
          <FavoriteIcon
            style={{
              color: 'red',
            }}
            onClick={onClickIcon}
          />
        ) : (
          <FavoriteBorderIcon onClick={onClickIcon} />
        )}
      </GridItem>
    </GridContainer>
  );
};

export default withStyles(buttonStyle)(ActionableSongListItem);
